export default "__VITE_ASSET__4a8a6de6__"